import React from 'react';
import sharedStyles from '../DefineMyCommunity.module.scss';
import { CalciteButton } from '@esri/calcite-components-react';


type DownloadResultsButtonProps = {
  handleClick: (event: React.MouseEvent) => void,
  kind: any
}

const DownloadResultsButton = ({handleClick, kind}: DownloadResultsButtonProps) => (
  <CalciteButton className={sharedStyles.MapButton} kind={kind} appearance='solid' iconStart='download-to' onClick={handleClick}>Download Results</CalciteButton>
);

export default DownloadResultsButton;
